import { InjectionToken } from '@angular/core';
export const DEPLOY_PREFIX = new InjectionToken<string>('DEPLOY_PREFIX');
